import { all, fork } from 'redux-saga/effects';
import { servicesSaga } from '@/features/services/servicesSaga';
import { authSaga } from '@/features/auth/authSaga';

export function* rootSaga() {
  yield all([fork(servicesSaga), fork(authSaga)]);
}
